export default function isAbortError(e) {
    return e instanceof Error && e.name === "AbortError";
}
//# sourceMappingURL=isAbortError.js.map